import Navbar from "../NavBar/Navbar"
import SideBar from "../NavBar/Sidebar"
import ContentPerfil from "./ContentPerfil"

interface ChildsProps {
    logout: () => void
}

const PerfilUsuario:React.FC<ChildsProps> = ({logout}) => {
    return(
        <div className="sidebar-noneoverflow">
            <Navbar logout={logout}/>
        
            <div className="main-container" id="container">
                <SideBar/>
                <ContentPerfil/>
            </div>
        </div>
    )
}


export default PerfilUsuario